<i18n>
{
	"en": {
		"etd": "Departure",
		"from": "From",
		"noTripsFound": "No trips have been generated yet",
		"removeConnection": "Remove connection",
		"to": "To",
		"tripNumber": "Trip"
	},
	"no": {
		"etd": "Avgang",
		"from": "Fra",
		"noTripsFound": "Ingen turer har blitt generert enda",
		"removeConnection": "Fjern kobling",
		"to": "Til",
		"tripNumber": "Tur"
	}
}
</i18n>

<template>
	<div>
		<t-grid
			v-if="generatedTrips.length"
			ref="grid"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="50"
			:items="generatedTrips"
			class="menu-grid"
			:selectableMode="['row']"
			selectable
			@selected="onRowsSelected"
			@rowDoubleClick="showTrip"
			@enter="showTrip"
		>
			<template #tripNumber="{ item }">
				{{ item.tripNumber }}
			</template>
			<template #fromAddress="{ item }">
				<div style="height: 16px;">{{ item.fromAddress.name }}</div>
				<div class="grid-cell-sub-line">{{ item.fromAddress.street }}, {{ item.fromAddress.postalCode }} {{ item.fromAddress.postalPlace }}</div>
			</template>
			<template #toAddress="{ item }">
				<div style="height: 16px;">{{ item.toAddress.name }}</div>
				<div class="grid-cell-sub-line">{{ item.toAddress.street }}, {{ item.toAddress.postalCode }} {{ item.toAddress.postalPlace }}</div>
			</template>
			<template #disconnect="{ item }">
				<t-icon-button
					icon="trash"
					intent="danger"
					type="bp"
					appearance="minimal"
					@click="disconnectTrip(item.id)"
				/>
			</template>
		</t-grid>
		<t-no-content-panel
			v-else
			:text="$t('noTripsFound')"
			style="height: 500px"
			icon="trip"
		/>
	</div>
</template>

<script>
import { mapState, mapActions } from '../store/tripTemplates.store';
import {
	displayDateFormat, storageDateFormat, displayDateFormatter, eventBus, dateExists
} from '@/core';
import moment from 'moment';

export default {
	name: 'GeneratedTrips',
	data() {
		return {
			defaultColumnDefinition: { resizable: true },
			rowsSelected: 0
		};
	},

	computed: {
		...mapState([ 'generatedTrips', 'templateDetails' ]),
		columnDefinitions() {
			return [
				{
					field: 'tripNumber',
					displayName: this.$t('tripNumber'),
					width: 75,
					type: 'number',
					comparableValueGetter: (item) => Number(item.tripNumber),
				},
				{
					field: 'etd.date',
					displayName: this.$t('etd'),
					valueGetter: ({ etd, atd }) => displayDateFormatter(atd && 'date' in atd ? atd.date : etd.date),
					width: 90,
					resizable: false,
					type: 'date',
					dateFormat: displayDateFormat,
					comparableValueGetter: ({ etd, atd }) => moment(atd && 'date' in atd ? atd.date : etd.date, storageDateFormat).toISOString(),
					cellClass(item) { return dateExists(item.atd) ? 'grid-cell-bold' : 'grid-cell-light'; }
				},
				{
					field: 'fromAddress',
					displayName: this.$t('from'),
					comparableValueGetter: ({ fromAddress }) => this.addressGetter(fromAddress),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'toAddress',
					displayName: this.$t('to'),
					comparableValueGetter: ({ toAddress }) => this.addressGetter(toAddress),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'disconnect',
					displayName: '',
					width: 40,
					filterable: false,
					resizable: false
				}
			];
		}
	},

	methods: {
		...mapActions(['setGeneratedTrips']),
		addressGetter(party) {
			if (!party) return '';
			if (typeof party === 'string') {
				return party;
			} else {
				return `${party.name} ${party.street} ${party.postalCode} ${party.postalPlace}`;
			}
		},
		onRowsSelected(ids) {
			this.rowsSelected = ids.length;
		},
		showTrip(tripId) {
			let trip = undefined;
			if (tripId) {
				trip = this.generatedTrips.find( (x) =>  x.id === tripId );
			} else {
				[trip] = this.$refs.grid.getSelectedItems();
				if (!trip) return;
			}
			eventBus.$emit('setEditTrip', trip.id);		// Does not really work - Magnus might have some plans regarding this.
			eventBus.$emit('toggleNewTripModal', true); // For a quick fix, eventbus.queue can be used (see OrderSearchInput).
		},
		disconnectTrip(tripId) {
			let trips = [...this.generatedTrips];
			trips.splice(this.generatedTrips.findIndex( (trip) => trip.id === tripId ), 1);
			this.setGeneratedTrips(trips);
		}
	},
};
</script>

<style lang="scss" scoped>

.menu-grid {
	margin-top: 20px;
	height: 500px;
	width: 100%;
}

</style>
